module.exports = __webpack_public_path__ + "img/wallpaper-pasta-e-broccoli.b3939ccd.png";